import { __awaiter, __generator } from "tslib";
import { createLabelDriver } from '../../new-libby/core/drivers';
import { compKey } from './key';
export var createRangeLabelDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    var labelDriver = createLabelDriver(base);
    return {
        value: function () { return labelDriver.text(); },
        isColor: function (color) { return __awaiter(void 0, void 0, void 0, function () {
            var styleAttr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, base.$('.label-container').attr('style')];
                    case 1:
                        styleAttr = (_a.sent()) || '';
                        return [2 /*return*/, styleAttr.includes(color)];
                }
            });
        }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map